/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it remember my calibration?`)
};

const es_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Recuerda mi calibración?`)
};

const de_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkt es sich meine Kalibrierung?`)
};

const nl_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onthoudt hij mijn kalibratie?`)
};

const fr_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se souvient-elle de ma calibration ?`)
};

const it_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricorda la mia calibrazione?`)
};

const pt_br2_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela lembra da minha calibração?`)
};

const pt_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A calibração fica guardada?`)
};

const ja_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`校正情報は記憶されますか?`)
};

const zh_ruler_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会记住我的校准吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_q3", locale)
	if (locale === "en") return en_ruler_faq_q3(inputs)
	if (locale === "es") return es_ruler_faq_q3(inputs)
	if (locale === "de") return de_ruler_faq_q3(inputs)
	if (locale === "nl") return nl_ruler_faq_q3(inputs)
	if (locale === "fr") return fr_ruler_faq_q3(inputs)
	if (locale === "it") return it_ruler_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_q3(inputs)
	if (locale === "pt") return pt_ruler_faq_q3(inputs)
	if (locale === "ja") return ja_ruler_faq_q3(inputs)
	return zh_ruler_faq_q3(inputs)
};